/*=========================================================================================
  File Name: betMutation.js
  Description: bet Module Mutations
==========================================================================================*/

export default {

  SET_BETTING(state, betData) {
      state.code = betData.gameCode,
      state.roomno = betData.roomno,
      state.roomorder = betData.roomorder,
      state.prevbettings = state.bettings,
      state.bettings = betData.bettings,
      state.prevtotbetamt = state.totbetamt,
      state.totbetamt = betData.totalBetAmount
  },
  ROLLBACK_BETTING(state) {
    state.code = state.gameCode,
    state.bettings = state.prevbettings,
    state.totbetamt = state.prevtotbetamt
  },
  BET_NOTIFY(state, messageCode) {
    state.notifications.show = true
    state.notifications.message = messageCode
  },
  BET_NOTIFY_CLEAR(state) {
    state.notifications.show = false
    state.notifications.message = ''
  },
  SET_INIT_BET(state, betData) {
    state.prevbettings = betData,
    state.bettings = betData
  },
  CLEAR_BETTING(state) {
    state.code = '',
    state.roomno = '',
    state.roomorder = '',
    state.bettings = [],
    state.prevbettings = [],
    state.totbetamt = 0,
    state.prevtotbetamt = 0
  }

}